module.exports = __webpack_public_path__ + "img/FPG-4.1a03dd13.jpg";